import type { SCH } from '@/shared/types'

interface SchSeed {
  code: string
  name: string
  level: SCH['level']
  region: SCH['region']
  lat: number
  lon: number
}

const SEEDS: SchSeed[] = [
  // Quân chủng level
  { code: 'SCH-QC', name: 'SCH Quân chủng PK-KQ', level: 'quan-chung', region: 'north', lat: 21.025, lon: 105.83 },

  // Sư đoàn
  { code: 'SCH-SD-N', name: 'SCH Sư đoàn KQ Bắc', level: 'su-doan', region: 'north', lat: 21.21, lon: 105.81 },
  { code: 'SCH-SD-C', name: 'SCH Sư đoàn KQ Trung', level: 'su-doan', region: 'central', lat: 16.05, lon: 108.2 },
  { code: 'SCH-SD-S', name: 'SCH Sư đoàn KQ Nam', level: 'su-doan', region: 'south', lat: 10.97, lon: 106.82 },
  { code: 'SCH-PK-N', name: 'SCH Sư đoàn PK Bắc', level: 'su-doan', region: 'north', lat: 21.5, lon: 105.85 },
  { code: 'SCH-PK-C', name: 'SCH Sư đoàn PK Trung', level: 'su-doan', region: 'central', lat: 14.0, lon: 108.5 },
  { code: 'SCH-PK-S', name: 'SCH Sư đoàn PK Nam', level: 'su-doan', region: 'south', lat: 10.5, lon: 106.7 },
]

function generateSCHs(): SCH[] {
  const list: SCH[] = SEEDS.map((s, idx) => ({
    id: `sch-${idx + 1}`,
    code: s.code,
    name: s.name,
    level: s.level,
    region: s.region,
    position: { lat: s.lat, lon: s.lon },
    status: idx === 5 ? 'standby' : 'normal',
    activeTargets: idx === 0 ? 1342 : Math.floor(60 + Math.random() * 80),
    activeAlerts: idx % 3 === 0 ? Math.floor(Math.random() * 5) : 0,
    lastSync: new Date(Date.now() - Math.random() * 600000).toISOString(),
  }))

  // Generate 46 trung-doan + tieu-doan SCH to reach 53 total
  const trungDoanRegions: { region: SCH['region']; baseLat: number; baseLon: number; count: number }[] = [
    { region: 'north', baseLat: 21.0, baseLon: 105.8, count: 16 },
    { region: 'central', baseLat: 15.5, baseLon: 108.5, count: 16 },
    { region: 'south', baseLat: 10.5, baseLon: 106.5, count: 14 },
  ]

  let counter = 8
  trungDoanRegions.forEach((r) => {
    for (let i = 0; i < r.count; i++) {
      const isTrung = i < r.count * 0.6
      const status: SCH['status'] = counter % 13 === 0 ? 'alert' : counter % 11 === 0 ? 'offline' : counter % 7 === 0 ? 'standby' : 'normal'
      list.push({
        id: `sch-${counter}`,
        code: `${isTrung ? 'SCH-TD' : 'SCH-D'}-${r.region.charAt(0).toUpperCase()}${String(i + 1).padStart(2, '0')}`,
        name: `${isTrung ? 'SCH Trung đoàn' : 'SCH Tiểu đoàn'} ${r.region === 'north' ? 'B' : r.region === 'central' ? 'T' : 'N'}${i + 1}`,
        level: isTrung ? 'trung-doan' : 'tieu-doan',
        region: r.region,
        position: {
          lat: r.baseLat + (Math.random() - 0.5) * 3,
          lon: r.baseLon + (Math.random() - 0.5) * 2.5,
        },
        status,
        activeTargets: status === 'offline' ? 0 : Math.floor(20 + Math.random() * 60),
        activeAlerts: status === 'alert' ? Math.floor(2 + Math.random() * 6) : status === 'standby' ? Math.floor(Math.random() * 2) : 0,
        lastSync: status === 'offline' ? new Date(Date.now() - 3600000 * 4).toISOString() : new Date(Date.now() - Math.random() * 300000).toISOString(),
      })
      counter++
    }
  })

  return list
}

export const SCHS: SCH[] = generateSCHs()
